import { TableCellProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TruxTableCell } from './trux-table-cell';


export const TruxDeleteTableCell = styled(TruxTableCell)<TableCellProps>(() => (
  {
    paddingLeft: "0px",
    maxWidth: "50px",
    width: "50px"
  }
));
